import { useState, useCallback } from 'react';
import { store as rtkStore } from 'redux/store';
import { fileuploadApi } from 'redux/services/fileuploadApi';

export const useLazyMultipleAttachmentUploadQuery = (options) => {
    const { multipleAttachmentUpload } = fileuploadApi.endpoints;
    const [result, setResult] = useState();
    const fetch = useCallback(async (params) => {
        const response =  await rtkStore.dispatch(multipleAttachmentUpload.initiate({ params }, {
            ...options,
            forceRefetch: true
        }));
        setResult(response);
        return response;
    }, [options, multipleAttachmentUpload]);


    return [
        fetch,
        result,
    ];
};
